module.exports = __webpack_public_path__ + "media/images/StanfordMagazineDigitalLogo-Blk-Red-RGB-b9343de6ab2800ab825b5907a1c3dfe4.svg";